export default "__VITE_ASSET__30964c86__"